import { render, staticRenderFns } from "./Recaptcha2.vue?vue&type=template&id=38cb5536&"
import script from "./Recaptcha2.vue?vue&type=script&lang=ts&"
export * from "./Recaptcha2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports